// CALLS FILTER TREE

import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

//Translation
import { withTranslation } from "react-i18next"

//  antd
import { TreeSelect, ConfigProvider } from "antd"
const { SHOW_PARENT } = TreeSelect

const CallFilter = props => {
  const [typeFilter, setTypeFilter] = useState(["all"])
  const [customize] = useState(true)
  const [series, setSeries] = useState([])
  const [filteredSeries, setFilteredSeries] = useState([])

  useEffect(() => {
    if (props.data) {
      setSeries(props.data)
    }
  }, [props.data])

  // Filter by selected types
  useEffect(() => {
    if (series != undefined) {
      setFilteredSeries([])
      if (typeFilter == "all") {
        setFilteredSeries(series)
      }
      if (typeFilter != "all" && typeFilter != "" && typeFilter != undefined) {
        for (let i = 0; i <= typeFilter.length; i++) {
          series.filter(data => {
            if (data.type?.includes(typeFilter[i])) {
              setFilteredSeries(filteredSeries => [...filteredSeries, data])
            }
          })
        }
      }
    }
  }, [series, typeFilter])

  const treeData = [
    {
      title: props.t("All"),
      value: "all",
      key: "all",

      children: [
        {
          title: props.t("Tracker"),
          value: "tracker",
          key: "tracker",
        },
        {
          title: props.t("Carephone"),
          value: "carephone",
          key: "carephone",
        },
        {
          title: props.t("Video"),
          value: "video",
          key: "video",
        },
        {
          title: props.t("Group video call"),
          value: "group",
          key: "group",
        },
        {
          title: props.t("Phone"),
          value: "phone",
          key: "phone",
        },
      ],
    },
  ]

  // Send filtered to parent
  useEffect(() => {
    props.setFilteredEntries(filteredSeries)
  }, [filteredSeries])

  // Changing the value of the filter
  const onChange = newValue => {
    console.log("FILTER CHANGED", newValue)
    setTypeFilter(newValue)
  }
  const customizeRenderEmpty = () => (
    <div className="mt-3" style={{ textAlign: "center" }}>
      <p>{props.t("Call type not found")}</p>
    </div>
  )

  const tProps = {
    treeData,
    value: typeFilter,
    onChange,
    allowClear: true,
    treeDefaultExpandAll: true,
    treeCheckable: true,
    showCheckedStrategy: SHOW_PARENT,
    style: {
      width: "100%",
    },
    placeholder: props.t("Filter"),
  }

  return (
    <>
      <ConfigProvider renderEmpty={customize && customizeRenderEmpty}>
        <TreeSelect {...tProps} />
      </ConfigProvider>
    </>
  )
}
CallFilter.propTypes = {
  t: PropTypes.any,
  data: PropTypes.any,
  setFilteredEntries: PropTypes.any,
  needsAlarmType: PropTypes.bool,
}

export default withTranslation()(CallFilter)
